/** Грубий множник на рядок LLM (клас моделі / API), без зовнішніх API. */
export type LlmPriceProfile = "economy" | "standard" | "premium";

export const DEFAULT_LLM_PRICE_PROFILE: LlmPriceProfile = "standard";

export function normalizeLlmPriceProfile(x: unknown): LlmPriceProfile {
  if (x === "economy" || x === "premium") return x;
  return "standard";
}

export function llmProfileFactor(p: LlmPriceProfile): number {
  switch (p) {
    case "economy":
      return 0.72;
    case "premium":
      return 1.38;
    default:
      return 1;
  }
}
